import { render, staticRenderFns } from "./DataBinding.vue?vue&type=template&id=2a425710&scoped=true&"
import script from "./DataBinding.vue?vue&type=script&lang=js&"
export * from "./DataBinding.vue?vue&type=script&lang=js&"
import style0 from "./DataBinding.vue?vue&type=style&index=0&id=2a425710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a425710",
  null
  
)

export default component.exports